module.exports = __webpack_public_path__ + "static/media/gallery (1).f464d7df.jpg";